import { Grid } from '@mantine/core';
import HeaderStatistic from '../HeaderStatistic';
import LazyLoadSpinner from '../LazyLoaderSpinner';

const ProductFeedStats = ({ stats, period, productFeed, currency }) => {
  if (!stats) {
    return (
      <Grid.Col span={12}>
        <Grid justify="center">
          <LazyLoadSpinner />
        </Grid>
      </Grid.Col>
    );
  }

  return (
    <Grid.Col span={12}>
      <Grid>
        <Grid.Col span="auto" ta="center">
          <HeaderStatistic title="Clicks" stats={stats} stat="clicks" id={productFeed.id} statKey="count" />
        </Grid.Col>
        <Grid.Col span="auto" ta="center">
          <HeaderStatistic
            title="Purchases"
            stats={stats}
            stat="purchases"
            percentageOfStat="clicks"
            id={productFeed.id}
            statKey="count"
          />
        </Grid.Col>
        <Grid.Col span="auto" ta="center">
          <HeaderStatistic
            title="Revenue"
            stats={stats}
            stat="purchases"
            id={productFeed.id}
            statKey="value"
            currency={currency}
          />
        </Grid.Col>
      </Grid>
    </Grid.Col>
  );
};

export default ProductFeedStats;
